export const usePersonalisation = () => {
  const { getItem } = useLocalStorage();
  const personalisation = ref<null | string[]>(null);

  const getPersonalisation = () => {
    if (personalisation.value === null) {
      const user = getItem("kudosity-register");
      const availablePersonalisations = [];

      if (user?.platform_use) {
        availablePersonalisations.push(user.platform_use);
      }
      if (availablePersonalisations.length > 0) {
        // Set personalisation only if available
        personalisation.value = availablePersonalisations;
      }
    }
    return personalisation.value;
  };

  const checkPersonalisedVisibility = (personalise: string) => {
    const personalise_array = personalise.split(" ");
    const visibility = ref(true);

    if (personalise_array.length === 0) visibility.value = false;

    if (personalisation.value === null) {
      getPersonalisation();
    }

    // If still no personalisation, and user wants to hide the content return false
    if (personalisation.value === null && personalise_array.includes("!default")) {
    //   console.log("Visibility: [No personalisation]", false);
      return false;
    }
    // console.log("User:", personalisation.value);
    // console.log("Item:", personalise_array);
    personalise_array.forEach((pref) => {
      const cleanPref = pref.replace("!", "");
      if (personalisation.value?.includes(cleanPref)) {
        visibility.value = pref.startsWith("!") ? false : true;
      }
    });
    // console.log("Visibility:", visibility.value);
    return visibility.value;
  };

  return { getPersonalisation,  checkPersonalisedVisibility };
};
